module.exports = __webpack_public_path__ + "static/media/win.aee5cd38.png";